import Moment from "moment";
import { extendMoment } from "moment-range";
import { Keys, Statuses } from "../constant/status";

const moment = extendMoment(Moment);

export const isOverdue = (orderDate, status, isFreeDrug) =>
  moment(orderDate).isBefore(moment().startOf("day")) &&
  ((status === Keys.order_required && isFreeDrug) ||
    ((status === Keys.drug_dispensed || status === Keys.drug_dispensed_free) && !isFreeDrug));

export const getNewCycle = (patient, lastCycle) => {
  const newCycle = {
    ...lastCycle,
    id: undefined,
    refills: lastCycle.refills && lastCycle.refills > 0 ? lastCycle.refills - 1 : null,
    orderIndex: lastCycle.orderIndex + 1,
    status: lastCycle.isFreeDrug ? Statuses[Keys.order_required].key : Statuses[Keys.drug_dispensed].key,
    estimatedDelivery: null,
    arriveDate: null,
    unitCost: 0,
    totalAmount: 0,
    billVoidedDate: null,
    billVoided: false,
    lotNumberDispensed: null,
    lotNumberReceived: null,
    accountNumber: null
  };

  const newAdministrationDate = moment(lastCycle.administrationDate).add(patient.orderFrequency, "days");
  newCycle.administrationDate = newAdministrationDate.toISOString();
  const daysBefore = moment(lastCycle.administrationDate).diff(moment(lastCycle.orderDate), "days");
  newCycle.orderDate = newAdministrationDate.subtract(daysBefore, "days").toISOString();
  return newCycle;
};

export const getOrderTimeStatus = (orderIndex, currentOrderIndex) => {
  // Handle null or undefined values
  if (orderIndex == null || currentOrderIndex == null) {
    return { key: "future" };
  }

  if (orderIndex === currentOrderIndex) {
    return { key: "current" };
  }

  if (orderIndex < currentOrderIndex) {
    return { key: "past" };
  }

  return { key: "future" };
};

export const getOrderTimeStatusLabel = (statusKey, t) => {
  const labels = {
    past: t("patient.order.time_status.past"),
    current: t("patient.order.time_status.current"),
    future: t("patient.order.time_status.future")
  };

  return labels[statusKey] || "";
};

export const getDefaultCycleNumber = (selectedOrderId, cycles, currentOrder) => {
  if (selectedOrderId !== null && selectedOrderId !== undefined && cycles) {
    const selectedCycle = cycles.find((cycle) => cycle.id === selectedOrderId);
    if (selectedCycle) {
      return selectedCycle.orderIndex + 1;
    }
  }
  return currentOrder.orderIndex + 1;
};
